import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { ConfirmBody } from './_ConfirmBody';
import { onSubscribeConfirm, onRequestConfirm } from './_confirmBus';

/*
    🔥 CONFIRM — Modal de react-bootstrap

    Mismo cuerpo que el propio; lo que cambia es el motor:
    backdrop, animación y trampa de foco los pone bootstrap.
*/

export const ConfirmReactBootstrapHost = () => {

    const [useRequest, setRequest] = useState(null);

    useEffect(() => onSubscribeConfirm((payload) => setRequest(payload)), []);

    const onResolve = (value) => {
        useRequest?.resolve(value);
        setRequest(null);
    };

    return (
        <Modal show={!!useRequest} onHide={() => onResolve(false)} centered
            backdrop="static" keyboard
            dialogClassName="LStudio__app_confirm_dialog"
            contentClassName="LStudio__app_confirm_wrap" >
            {
                useRequest && (
                    <ConfirmBody {...useRequest.options}
                        onConfirm={(value) => onResolve(value)}
                        onCancel={() => onResolve(false)} />
                )
            }
        </Modal>
    );
};

export const onConfirmReactBootstrap = (options) => onRequestConfirm(options);
